import { useQuery } from '@tanstack/react-query';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationReadiness } from '@/types/automations.ts';
import { AUTOMATION_BUILDER_READINESS_KEY } from '@/utils/queryKeys.ts';
import { get_automation_builder_readiness_url } from '@/utils/urls.ts';

const useRetrieveAutomationReadiness = (versionId?: string, enabled = true) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<AutomationReadiness, Error>({
    queryKey: AUTOMATION_BUILDER_READINESS_KEY(automationId, versionId),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_builder_readiness_url(automationId, versionId));
      return response.data;
    },
    enabled: enabled && !!automationId && !!versionId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};

export default useRetrieveAutomationReadiness;
